import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import type { CatalogRow } from 'src/motornet/types';
import { formatCurrency } from 'src/utils';
import { DetailGrid } from './DetailGrid';
import { Chip, manufacturerCodes, rowLabel, rowYears } from './helpers';
import MotornetPanel from './MotornetPanel';
import ProviderPanel from './ProviderPanel';
import { WizardLayoutContext } from './WizardFields';

const RowReference = ({ row }: { row: CatalogRow }) => {
	const { t } = useTranslation();

	return (
		<DetailGrid
			items={[
				{
					label: t('vehicle_association_list_price', { defaultValue: 'Listino netto' }),
					value: row.listPrice == null ? '-' : formatCurrency(row.listPrice),
				},
				{
					label: t('vehicle_association_vehicle_code', { defaultValue: 'Cod. veicolo' }),
					value: row.motornet?.vehicleCode ?? '-',
				},
				{
					label: t('vehicle_association_manufacturer_code', { defaultValue: 'Cod. costr.' }),
					value: manufacturerCodes(row).join(' / ') || '-',
				},
				{ label: t('year', { defaultValue: 'Anno' }), value: rowYears(row).join(' / ') || '-' },
			]}
		/>
	);
};

type Props = {
	row: CatalogRow | undefined;
	chip: Chip | undefined;
	onClose: () => void;
};

const AssociationModal = ({ row, chip, onClose }: Props) => (
	<Modal show={!!row && !!chip} onHide={onClose} size="lg" centered scrollable>
		{row && chip && (
			<>
				<Modal.Header closeButton className="align-items-start pb-0">
					<Modal.Title className="fs-5 fw-bold">{rowLabel(row)}</Modal.Title>
				</Modal.Header>
				<div className="px-3 pt-2 pb-3 border-bottom">
					<RowReference row={row} />
				</div>
				<Modal.Body className="p-0">
					<WizardLayoutContext.Provider value="stacked">
						{chip === 'motornet' ? (
							<MotornetPanel key={`${row.versionKey}-motornet`} row={row} onClose={onClose} />
						) : (
							<ProviderPanel key={`${row.versionKey}-${chip}`} row={row} provider={chip} onClose={onClose} />
						)}
					</WizardLayoutContext.Provider>
				</Modal.Body>
			</>
		)}
	</Modal>
);

export default AssociationModal;
